(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-2cols"] && !Shopify.designMode) return;
  try {
    
class ImageComparison2X extends HTMLElement {
  constructor() {
    super();
    this.handle = this.querySelector('.comparison__handle');
    this.isDragging = false;
  }

  connectedCallback() {
    this.handle.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.onDrag.bind(this));
    document.addEventListener('mouseup', this.stopDrag.bind(this));

    this.handle.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });
    document.addEventListener('touchmove', this.onDrag.bind(this), { passive: true });
    document.addEventListener('touchend', this.stopDrag.bind(this));
  }

  startDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.classList.add('is-grabbing');
  }

  stopDrag() {
    this.isDragging = false;
    this.classList.remove('is-grabbing');
  }

  onDrag(e) {
    if (!this.isDragging) return;

    const rect = this.getBoundingClientRect();
    const event = e.touches ? e.touches[0] : e;
    const x = event.clientX - rect.left;

    let percent = (x / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));

    this.style.setProperty('--percent', percent + '%');
  }
}

customElements.define('before-after-comparison', ImageComparison2X);

// Tabs functionality
document.querySelectorAll('.ba2xols-tabs button').forEach(btn => {
  btn.addEventListener('click', () => {
    const tab = btn.getAttribute('data-tab');
    document.querySelectorAll('.ba2xols-tabs button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    document.querySelectorAll('[data-tab-content]').forEach(slider => {
      slider.style.display = slider.getAttribute('data-tab-content') === tab ? 'flex' : 'none';
      setTimeout( () => {
        slider.className = slider.getAttribute('data-tab-content') === tab ? 'active' : '';
      }, 200 );
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-page"] && !Shopify.designMode) return;
  try {
    
class BAMultiCompare extends HTMLElement {
  connectedCallback() {
    const handle = this.querySelector('.baMC-handle');
    let dragging = false;

    const updatePosition = clientX => {
      const rect = this.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      this.style.setProperty('--percent', percent + '%');
    };

    handle.addEventListener('mousedown', () => dragging = true);
    document.addEventListener('mouseup', () => dragging = false);
    document.addEventListener('mousemove', e => dragging && updatePosition(e.clientX));

    handle.addEventListener('touchstart', () => dragging = true, { passive: true });
    document.addEventListener('touchend', () => dragging = false);
    document.addEventListener('touchmove', e => {
      if (!dragging) return;
      updatePosition(e.touches[0].clientX);
    }, { passive: true });
  }
}

customElements.define('before-after-mc', BAMultiCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
class ImageComparison extends HTMLElement {
  constructor() {
    super();
    this.handle = this.querySelector('.comparison__handle');
    this.isDragging = false;
    this.layout = this.dataset.layout || 'horizontal';
  }

  connectedCallback() {
    this.handle.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.onDrag.bind(this));
    document.addEventListener('mouseup', this.stopDrag.bind(this));
    
    this.handle.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });
    document.addEventListener('touchmove', this.onDrag.bind(this), { passive: true });
    document.addEventListener('touchend', this.stopDrag.bind(this));

    this.handle.addEventListener('keydown', this.onKeydown.bind(this));
  }

  startDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.classList.add('is-grabbing');
  }

  stopDrag() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.classList.remove('is-grabbing');
  }

  onDrag(e) {
    if (!this.isDragging) return;
    
    const rect = this.getBoundingClientRect();
    const event = e.touches ? e.touches[0] : e;
    let position;

    if (this.layout === 'horizontal') {
      const x = event.clientX - rect.left;
      position = (x / rect.width) * 100;
    } else {
      const y = event.clientY - rect.top;
      position = (y / rect.height) * 100;
    }
    
    position = Math.max(0, Math.min(100, position));
    this.style.setProperty('--percent', `${position}%`);
  }
  
  onKeydown(e) {
    let currentPercent = parseFloat(this.style.getPropertyValue('--percent'));
    const step = e.shiftKey ? 10 : 2; // Większy krok z Shiftem

    let changed = false;
    if (this.layout === 'horizontal') {
      if (e.key === 'ArrowLeft') { currentPercent -= step; changed = true; } 
      else if (e.key === 'ArrowRight') { currentPercent += step; changed = true; }
    } else {
      if (e.key === 'ArrowUp') { currentPercent -= step; changed = true; }
      else if (e.key === 'ArrowDown') { currentPercent += step; changed = true; }
    }
    
    if (changed) {
      e.preventDefault();
      const newPosition = Math.max(0, Math.min(100, currentPercent));
      this.style.setProperty('--percent', `${newPosition}%`);
    }
  }
}
customElements.define('before-after-comarison', ImageComparison);

  } catch(e) { console.error(e); }
})();
})();
